import { pathOr } from 'ramda';

export default (document, id) => ['clientWidth', 'clientHeight']
  .map(val =>
    pathOr(0, [val], document.getElementById(id)));



// WEBPACK FOOTER //
// ./shared/lib/get-client-dimensions/index.js